import { useMutation } from 'react-query';

import { extractDelayedActivitiesCsv as mutationFn } from 'api/endPoints/extractDelayedActivitiesCsv';

import { IFilter } from 'components/Dashboards/Project/Components/CustomDashboard/utils/utils.type';

const useMutationExtractDelayedActivitiesCsv = () => {
    return useMutation<unknown, QueryError, ExtractDelayedActivitiesCsv>((params) => mutationFn(params));
};

interface ExtractDelayedActivitiesCsv {
    compareVersionId?: number;
    id: number[] | null;
    filter: { filters: IFilter[] };
    fileName: string;
}

export { useMutationExtractDelayedActivitiesCsv };
